import { render, staticRenderFns } from "./ImprimirReporteBuroCredito.vue?vue&type=template&id=b5cb9ce8&scoped=true&"
import script from "./ImprimirReporteBuroCredito.vue?vue&type=script&lang=js&"
export * from "./ImprimirReporteBuroCredito.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirReporteBuroCredito.vue?vue&type=style&index=0&id=b5cb9ce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb9ce8",
  null
  
)

export default component.exports